import React, { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import Page from '../../index'
import PageSectionHeader from '../../../features/components/PageSectionHeader'

import {
  clearGetSocialReturnOnInvestmentReport,
  getSocialReturnOnInvestmentReport
} from '../../../modules/actions/socialReturnOnInvestment'
import { openForm } from '../../../modules/actions/forms'

import ReportContent from './ReportContentOld'
import SroiReportPayloadEdit from './SroiReportPayloadEditOld'
import Button from '../../../components/Button'

import { SROI_REPORT_PAYLOAD_EDIT } from '../../../constants/forms'

// Requirement is just to fetch id: 1
export const HARDCODED_SROI_REPORT_ID = 1

const SocialReturnOnInvestmentOld = () => {
  const dispatch = useDispatch()

  const openSroiReportEditForm = useCallback(
    id => {
      dispatch(openForm({ id: HARDCODED_SROI_REPORT_ID, formName: SROI_REPORT_PAYLOAD_EDIT }))
    },
    [dispatch]
  )

  const fetchSroiReportHandler = useCallback(() => {
    dispatch(getSocialReturnOnInvestmentReport({ id: HARDCODED_SROI_REPORT_ID }))
  }, [dispatch])

  useEffect(() => {
    fetchSroiReportHandler()
  }, [fetchSroiReportHandler])

  useEffect(() => {
    return () => {
      dispatch(clearGetSocialReturnOnInvestmentReport())
    }
  }, [dispatch])

  return (
    <Page helmetTitle="sroi">
      <Button onClick={openSroiReportEditForm}>Edit SROI Report</Button>
      <SroiReportPayloadEdit fetchSroiReportHandler={fetchSroiReportHandler} />
      <PageSectionHeader title="Social Impact Evaluation" />
      <ReportContent />
    </Page>
  )
}

export default SocialReturnOnInvestmentOld
